import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Spinner } from 'libs.nucleus';
import { NumberChart } from 'libs.react';
import { DataReportsContext } from '../../../../contexts/data_reports/data_reports.context';
import { buildNumberChartDatasets } from '../../../utils/number_chart.utils';
export const NumberChartWrapper = ({ resultSets, pivotConfig, style, palette, numberValues, showLabels, showLegend, isLoading, }) => {
    // `applyValueFormatting` reflects whether this study report was opened via the new flow (has `rid`).
    // Only then do we apply Cube formatting, full decimals, and SSP-4192 palette/CF colors; legacy
    // reports render raw values with the historical default text color (SSP-3972 / SSP-4129 / SSP-4192).
    const { applyValueFormatting } = useContext(DataReportsContext);
    if (isLoading || !resultSets || resultSets.length === 0) {
        return (_jsx("div", { className: 'flex items-center justify-center size-full', children: _jsx(Spinner, { size: 'xl' }) }));
    }
    const datasets = buildNumberChartDatasets({
        resultSets,
        pivotConfig,
        style,
        palette,
        numberValues,
        showLabels,
        showLegend,
        applyValueFormatting,
    });
    return _jsx(NumberChart, { data: { datasets }, preserveDecimals: applyValueFormatting });
};
